import parseCookie from "../utils/helpers/parse-cookie";

const getBifrostWebClientId = () => process.env.BIFROST_WEB_CLIENT_ID || "";

const getBifrostDeviceId = () =>
    parseCookie("bifrost_device_id") || parseCookie("statsigStableId") || parseCookie("UUID") || "";

const getBifrostAuthBaseUrl = () => {
    if (process.env.BIFROST_AUTH_SERVICE_BASE_URL) {
        return process.env.BIFROST_AUTH_SERVICE_BASE_URL;
    }
    switch (process.env.HOST_ENV) {
    case "PRODUCTION":
        return "https://auth.cars24.com.au";
    case "STAGING":
    case "LNOD":
        return "https://auth-service-stage.qac24svc.dev";
    case "QA":
    default:
        return "https://auth-service-stage.qac24svc.dev";
    }
};

const exchangeAuthCode = async (code) => {
    const baseUrl = getBifrostAuthBaseUrl();
    const deviceId = getBifrostDeviceId();
    const response = await fetch(`${baseUrl}/oauth2/token-exchange`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(deviceId ? { "x-device-id": deviceId } : {})
        },
        body: JSON.stringify({
            exchange_type: "code_to_client",
            code,
            client_id: getBifrostWebClientId(),
            session_info: {
                platform: "WEB",
                device_name: "web_browser"
            }
        })
    });

    if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw errData;
    }

    return response.json();
};

const exchangeOldAuToken = async (token) => {
    const baseUrl = getBifrostAuthBaseUrl();
    const deviceId = getBifrostDeviceId();
    const response = await fetch(`${baseUrl}/oauth2/token-exchange`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(deviceId ? { "x-device-id": deviceId } : {})
        },
        body: JSON.stringify({
            exchange_type: "au_to_client",
            token,
            client_id: getBifrostWebClientId(),
            session_info: {
                platform: "WEB",
                device_name: "web_browser"
            }
        })
    });

    if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw errData;
    }

    return response.json();
};

export default { exchangeAuthCode, exchangeOldAuToken };
